import { render, staticRenderFns } from "./NotasAtualizacao.vue?vue&type=template&id=3730d12d&"
import script from "./NotasAtualizacao.vue?vue&type=script&lang=js&"
export * from "./NotasAtualizacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports